class TrustBadges extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-trust-badges-scroller]');
    this.speed = Number(this.dataset.scrollSpeed || 24);
    this.paused = false;
    this.lastTimestamp = 0;
    this.loopDistance = 0;

    if (this.dataset.autoScroll === 'false' || !this.scroller || !this.classList.contains('trust-badges--bar')) return;

    this.prepareLoop();
    if (!this.canScroll() || this.loopDistance <= 0) return;

    this.addEventListener('pointerenter', () => {
      this.paused = this.dataset.pauseOnHover !== 'false';
    });
    this.addEventListener('pointerleave', () => {
      this.paused = false;
    });

    this.animationFrame = window.requestAnimationFrame((timestamp) => this.animate(timestamp));
  }

  disconnectedCallback() {
    window.cancelAnimationFrame(this.animationFrame);
  }

  prepareLoop() {
    const originalItems = Array.from(this.scroller.children).filter((item) => !item.dataset.trustBadgeClone);

    if (originalItems.length < 2) return;

    const styles = window.getComputedStyle(this.scroller);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    const originalWidth = this.scroller.scrollWidth;
    this.loopDistance = originalWidth + gap;

    let cloneSets = 0;

    while (this.scroller.scrollWidth < this.loopDistance + this.scroller.clientWidth && cloneSets < 6) {
      originalItems.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.dataset.trustBadgeClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        this.disableCloneInteractivity(clone);
        this.scroller.appendChild(clone);
      });

      cloneSets += 1;
    }
  }

  disableCloneInteractivity(clone) {
    Array.from(clone.attributes).forEach((attribute) => {
      if (attribute.name.startsWith('data-shopify')) {
        clone.removeAttribute(attribute.name);
      }
    });

    const focusableSelector = 'a, button, input, select, textarea, [tabindex]';
    const focusableElements = clone.matches(focusableSelector)
      ? [clone, ...clone.querySelectorAll(focusableSelector)]
      : clone.querySelectorAll(focusableSelector);

    focusableElements.forEach((focusable) => {
      focusable.setAttribute('tabindex', '-1');
    });
  }

  animate(timestamp) {
    if (!this.lastTimestamp) this.lastTimestamp = timestamp;

    const elapsed = timestamp - this.lastTimestamp;
    this.lastTimestamp = timestamp;

    if (!this.paused && this.canScroll()) {
      this.scroller.scrollLeft += (this.speed * elapsed) / 1000;

      if (this.scroller.scrollLeft >= this.loopDistance) {
        this.scroller.scrollLeft -= this.loopDistance;
      }
    }

    this.animationFrame = window.requestAnimationFrame((nextTimestamp) => this.animate(nextTimestamp));
  }

  canScroll() {
    return this.scroller.scrollWidth > this.scroller.clientWidth + 1;
  }
}

if (!customElements.get('trust-badges')) {
  customElements.define('trust-badges', TrustBadges);
}
